import { createContext, useContext, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

function usePrevious(value) {
  let ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export const PathContext = createContext({});

export function usePath() {
  return useContext(PathContext);
}

export function PathProvider({ children }) {
  let pathname = usePathname();
  let previousPathname = usePrevious(pathname);
  return (
    <PathContext.Provider value={{ previousPathname }}>
      {children}
    </PathContext.Provider>
  );
}
